// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Articles_Articles__Yt9gN {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Aktive Grotesk', sans-serif;    
    font-size: 18px;
    color: #0a2945; 
    flex-wrap: wrap;
    margin-bottom: 2em;
}
.Articles_ArticlesTitle__O-tS9 {
    margin-top: 90px;
    width: 100%;
    font-family: 'Cocon Bold', sans-serif;
    font-size: 3em;
    font-weight: 700;
    text-align: center;
}
.Articles_ArticlesBorder__9yPHe {
    width: 90%;
    margin: 0 5%;
    border-bottom: 1px solid #ccc;
}
.Articles_CoveredArticle__nL8Ii {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin: 2rem;
    width: 43%;
    border: 1px solid lightgray;
    box-shadow: 0px 0px 30px 15px #0000002b;
    cursor: pointer;
    min-height: 8em;
    padding: 0.5em;
}
.Articles_CoveredArticle__nL8Ii img {
    margin: 1em;
    max-height: 4em;
    max-width: 240px;
}
.Articles_CoveredArticle__nL8Ii:hover {
    background-color: #f5f5f5;
    transition: 0.5s;
    box-shadow: 10px 10px 0 #FBC638;
}

@media (max-width: 1200px) {
    .Articles_Articles__Yt9gN {
        flex-direction: column;
        align-items: center;
    }
    .Articles_CoveredArticle__nL8Ii {
        width: calc(90% - 2em);
        justify-content: left;
        margin: 1em;
    }
}

@media (max-width: 630px) {
    .Articles_ArticlesTitle__O-tS9 {
        font-size: 2em;
    }
    .Articles_Articles__Yt9gN {
        font-size: 16px;
    }
    .Articles_CoveredArticle__nL8Ii {
        flex-direction: column;
        justify-content: left;
        margin: 0.5em 1em;
    }
    .Articles_CoveredArticle__nL8Ii img {
        max-height: 4em;
        max-width: 180px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Articles/Articles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,qCAAqC;IACrC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,uCAAuC;IACvC,eAAe;IACf,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,qBAAqB;QACrB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,qBAAqB;QACrB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".Articles {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Aktive Grotesk', sans-serif;    \n    font-size: 18px;\n    color: #0a2945; \n    flex-wrap: wrap;\n    margin-bottom: 2em;\n}\n.ArticlesTitle {\n    margin-top: 90px;\n    width: 100%;\n    font-family: 'Cocon Bold', sans-serif;\n    font-size: 3em;\n    font-weight: 700;\n    text-align: center;\n}\n.ArticlesBorder {\n    width: 90%;\n    margin: 0 5%;\n    border-bottom: 1px solid #ccc;\n}\n.CoveredArticle {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    margin: 2rem;\n    width: 43%;\n    border: 1px solid lightgray;\n    box-shadow: 0px 0px 30px 15px #0000002b;\n    cursor: pointer;\n    min-height: 8em;\n    padding: 0.5em;\n}\n.CoveredArticle img {\n    margin: 1em;\n    max-height: 4em;\n    max-width: 240px;\n}\n.CoveredArticle:hover {\n    background-color: #f5f5f5;\n    transition: 0.5s;\n    box-shadow: 10px 10px 0 #FBC638;\n}\n\n@media (max-width: 1200px) {\n    .Articles {\n        flex-direction: column;\n        align-items: center;\n    }\n    .CoveredArticle {\n        width: calc(90% - 2em);\n        justify-content: left;\n        margin: 1em;\n    }\n}\n\n@media (max-width: 630px) {\n    .ArticlesTitle {\n        font-size: 2em;\n    }\n    .Articles {\n        font-size: 16px;\n    }\n    .CoveredArticle {\n        flex-direction: column;\n        justify-content: left;\n        margin: 0.5em 1em;\n    }\n    .CoveredArticle img {\n        max-height: 4em;\n        max-width: 180px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Articles": `Articles_Articles__Yt9gN`,
	"ArticlesTitle": `Articles_ArticlesTitle__O-tS9`,
	"ArticlesBorder": `Articles_ArticlesBorder__9yPHe`,
	"CoveredArticle": `Articles_CoveredArticle__nL8Ii`
};
export default ___CSS_LOADER_EXPORT___;
